export default "__VITE_ASSET__BraeK8hL__"